<template>
  <ModCheck :iconList="iconList" :selectKey="getKey" @select="checkMode"></ModCheck>
</template>
<script>
import ModCheck from '@/components/taskFilterBox/modCheck'
import { mapMutations, mapState } from 'vuex'
export default {
  components: {
    ModCheck
  },
  data() {
    return {
      iconList: [{
        icon: 'iconicon_tabulation',
        components: 'table',
        key: 1,
        text: '列表'
      },{
        icon: 'iconicon_card_mode',
        components: 'chart',
        key: 2,
        text: '图表'
      }],
    }
  },
  computed: {
    ...mapState("file/file", {
      modelView: (state) => state.modelView,
    }),
    getKey() {
      let item =  this.iconList.find(res => res.components === this.modelView)
      return item ? item.key : 1
    }
  },
  methods: {
    ...mapMutations('file/file', ['set_mod_view']),
    checkMode(idx) {
      if(this.iconList[idx].components === this.modelView) return
      this.set_mod_view(this.iconList[idx].components)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.filter-mode-check {
  display: flex;
  align-items: center;
  padding: 3px;
  @include bgColorOpacity(.08);
  border-radius: 6px;
  margin-left: 16px;
  .item {
    box-sizing: border-box;
    width: 26px;
    height: 26px;
    text-align: center;
    border-radius: 4px;
    @include fontColorOpacity(.6);
    font-size: 12px;
    cursor: pointer;
    &.check {
      background-color: #fff;
      @include fontColorOpacity(.8);
    }
  }
}
</style>
